<template>
    <section class="blockElement" >  
        
			
        <div class="container-fluid">
        	<!-- <div class="riskWarningMsg d-md-none">
                <small>{{$t('riskWarningMsg')}}</small>
            </div> -->
            <div class="innerInclude p_login">
                
				<div class="row"> 
					
					<div class="col-12 col-md-4 text-center d-flex blueBG beforeBG vh_100 align-items-center justify-content-center">
						<div class="d-none d-md-block"> 
							<div class="titleArera Loginlogo">
								<router-link :to="'/'" class="green">
							   		<img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
								</router-link>
							</div>
							<div class="PortfoliosTitle"> 
								<div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
									<div class="carousel-inner">
										<div class="carousel-item active">
											<!-- <p>{{ $t('welcomeMsg') }}</p> -->
											<img src="../../../../static/fxView/images/login_trading_platform.svg" alt="Banner">
											<h3>{{$t('welcomeMsgHeadone')}}</h3>
											<p>{{$t('welcomeMsg1')}}</p>       
										</div>
										<div class="carousel-item">
											<img src="../../../../static/fxView/images/login_trader_toolbox.svg" alt="Banner">
											<h3>{{$t('welcomeMsgHeadtwo')}}</h3>
											<p>{{$t('welcomeMsg2')}}</p>
										</div>
										<div class="carousel-item">
											<img src="../../../../static/fxView/images/login_download_platform.svg" alt="Banner">
											<h3>{{$t('welcomeMsgHeadthree')}}</h3>
											<p>{{$t('welcomeMsg3')}}</p>
										</div>
									</div>
									<div class="clearfix"></div>
									<ul class="carousel-indicators mt-3">
										<li data-target="#demo" data-slide-to="0" class="active"></li>
										<li data-target="#demo" data-slide-to="1"></li>
										<li data-target="#demo" data-slide-to="2"></li>
									</ul>
								</div>
							</div> 
						</div>
					</div>
					<div class="col-12 col-md-8 p-0 d-flex vh_100 align-items-center">
						<div class="sign_insec">
							<div class="mobileLogo d-md-none">
								<router-link :to="'/'" class="green">
									<img src="../../../../static/fxView/images/fxview_logo.svg" alt="fxView">
								</router-link>
							</div>
							<!--loader - message--->
							<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
							<!--<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>-->
							<div>
								<div class="warningMsg mb-3 p-3 " v-if="response_msg != '' && msg_type == 'error'">
									<div class="infomsg d-flex align-items-center justify-content-between">
										<div class="d-flex w-100 align-items-center">
											<p v-html="response_msg">
												<feather type="alert-circle"></feather>
											</p>
										</div>  
										<feather type="x" @click="hideFunc()"></feather>  
									</div> 
								</div>
								<div class="warningMsg successMsg mb-3 p-3 " v-if="response_msg != '' && msg_type == 'success'">
									<div class="infomsg d-flex align-items-center justify-content-between">
										<div class="d-flex w-100 align-items-center">
											<p v-html="response_msg">
												<feather type="check"></feather>
											</p>  
										</div>  
										<feather type="x" @click="hideFunc()"></feather>
									</div> 
								</div>
							</div>
							<flash-message></flash-message>	
							<div class="stepForm" v-if="!gAuthenticatorEnabled">
								<div class="subtitle d-flex w-100">
									<h3>{{$t('signin')}}</h3>
								</div>

								<div class="form-group field-wrapper">
									<input   type="text" name="Email" v-model="email" class="float-field form-control"  v-validate="'required|email'"   :class="({ 'is-invalid': submitted && errors.has('Email') })" ref="emailInput" autocomplete="undefined"/>
									<label for="username"  class="float-label">{{$t('emailaddress')}}</label>
									<p class="error" v-for="error in errors.collect('Email')">{{ error }}</p>
								</div>
								<div class="form-group field-wrapper">
									<input   :type="inputtype" name="Password" v-model="password" class="float-field form-control" v-validate="'required'"   :class="({ 'is-invalid': submitted && errors.has('Password') })"    ref="passwordInput" v-on:keyup.enter="submit" autocomplete="undefined"/>
									<label for="password"  class="float-label">{{$t('password')}}</label>
									<feather :type="iconType" class="toggle-password" @click="switchVisibility"></feather>
									<p class="error" v-for="error in errors.collect('Password')">{{ error }}</p>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex justify-content-between align-items-center submitButton">
									<button class="prism_btn btn_sm" v-on:click="submit()"> {{$t('logIn')}}</button> 
									
									<div class="forgot_sec">
										<a href="#" @click="forgotPasswordRoute()"  class="forgotpassword d-flex align-items-center">
											<feather type="lock" class="mr-1"></feather> {{$t('forgotPassword')}} 
										</a>    
									</div>
								</div> 
								 
								<div class="mt-4 forgot_sec mb-2">
									<p>{{$t('donthaveaccount')}} <a href="#" @click="gotoRegister()" > {{$t('signuphere')}} </a></p>
								</div> 
								<app-language :page="'login'"> </app-language> 
								<div class="charlgateMsg border-top pt-2 mt-2">
                                    <small>{{$t('charlgateMsg')}}</small>
                                </div>
							</div>
							
							<div class="stepForm" v-else>
								<div class="subtitle w-100">
									<h3 class="mb-3">{{$t('varify2step')}}</h3>
									<p class="mb-4" v-html="$t('googleOtp')"></p>
								</div>
								<div class="form-group field-wrapper">
									<input   placeholder=" " type="text" name="code" v-model="code" class="float-field form-control"  v-validate="'required'"   :class="{ 'is-invalid': submittedCode && errors.has('code') }" ref="codeInput" />
									<label for="username"  class="float-label">{{$t('EnterAuthCode')}}</label>
									<p class="error" v-for="error in errors.collect('code')">{{ error }}</p>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex justify-content-between align-items-center submitButton">
									<button class="prism_btn btn_sm" v-on:click="submitCode()"> {{$t('submit')}}</button>
									
									<div class="forgot_sec">
										<a href="#" class="forgotpassword d-flex" @click="gAuthenticatorEnabled = false">
											<feather type="lock" class="mr-1"></feather> {{$t('backLogin')}} 
										</a>    
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
		<div class="fixedBarBottom fullwidth register-page-fixedbar">
			<div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('footerMsz2')"></p>
                <a href="https://fxview.com/assets/pdf/legal-document/Risk-Disclosure-and-Warnings-Notice-August-2023.pdf" target="_blank">{{$t('riskDisclaimer')}}</a> 
            </div>
		</div>
    </section>
</template>
<script>
    var CryptoJS = require("crypto-js"); 
	const crypto = require('crypto');
    import * as types from '@/types'
    import { mapActions } from 'vuex'
	import language from '../shared/language_before_login'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Login',
        mixins: [fxViewMixins],
        data() {
            return {
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                "email" : "",
                "password" : "",
                submitted: false,
                showpassword: false,
                iconType : 'eye-off',
                inputtype : 'password',
				
				code : '',
				submittedCode : false,
				gAuthenticatorEnabled : false
				
            }
        },
		components: {
            appLanguage: language
        },
        methods:{
			gotoRegister(){
				this.$trackEvent('FXView+Login+Register');
				this.$router.push('/register')
			},
			forgotPasswordRoute(){
				this.$trackEvent('FXView+Login+Forgot+Password');
				this.$router.push('/forgot-password')
			},
			hideFunc(){
				this.response_msg = ''
				this.msg_type =''
			},
            ...mapActions({
                _runUserLogin: types.RUN_USER_LOGIN,
				_runUserLogin2FA: types.RUN_USER_LOGIN_2FA,
				_runstateLoad: types.RUN_STATE_LOAD
            }),
            switchVisibility() {
                this.showpassword = !this.showpassword
                if(this.showpassword){
                    this.inputtype = 'text'
                    this.iconType = 'eye'
                }else{
                    this.inputtype = 'password'
                    this.iconType = 'eye-off'
                } 
            },
            submit(){
				this.$trackEvent('FXView+Login+Sign+In');
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "email": _that.email,
                                "password": _that.password,
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runUserLogin(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
			submitCode(){
				const _that = this
                _that.submittedCode = true;
				
				const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');
				
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
								"google_token" : _that.code.toString(),
                                "email": _that.email,
                                "password": hashedstr
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runUserLogin2FA(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
			},
			
			jsonFunc(){
				let json1 = {
					'key1': 'gg',
					'key2' : 'gfgfg'
				}
				let json2 = {
					'key2': '2',
					'key3' : '2'
				}
				let count = 0 ;
				for(let key in json1){
					count ++
					if(json2[key]){
						
					}else{
						json2[key] = json1[key]
					}
					
					if(count == Object.keys(json1).length){
						console.log('json2-----',json2)
					}
				}
			}
        },
        created(){
			this.$trackEvent('FXView+Login+Pageview');
            // const CryptoJS = require("crypto-js");
			//this.jsonFunc()
            if("verify" in this.$route.query){

                const encyptKey =  this.$route.query['verify']
                const crypto = require('crypto');

                let mykey = crypto.createDecipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let mystr = mykey.update('ef77c279b79794686dc4d1b41b8c2b91', 'hex', 'utf8')
                mystr += mykey.final('utf8');
            }  
			let lastPath = localStorage.getItem('lastPath')
		    let temp_token = localStorage.getItem('temp_token')
		    if(temp_token){
		    	localStorage.removeItem("temp_token")
		        this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this, 'auth':temp_token, 'path':lastPath}})
		    }else if(this.$route.query.auth){
		    	this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this, 'auth':temp_token, 'path':lastPath}})
		    }
            // https://dev.finvasia.com:8083/verifyuser/ef77c279b79794686dc4d1b41b8c2b91
            
            /*var mykey = CryptoJS.createDecipher('aes-128-cbc', 'mypassword');
            var mystr = mykey.update('34feb914c099df25794bf9ccb85bea72', 'hex', 'utf8')
            mystr += mykey.final('utf8');

            var bytes  = CryptoJS.AES.decrypt("34feb914c099df25794bf9ccb85bea72", 'abc');
            var originalText = bytes.toString(CryptoJS.enc.Utf8);
            console.log(originalText);*/


            /*var bytes = CryptoJS.HmacSHA1("f7412f588099f7f0ba739e71dbc139d735c9d522", "F*V(I)^E#1108@3")
            var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            console.log(decryptedData);*/

            // https://dev.finvasia.com:8083?f7412f588099f7f0ba739e71dbc139d735c9d522
            /*const CryptoJS = require("crypto-js");
            console.log(CryptoJS.HmacSHA1.decrypt("f7412f588099f7f0ba739e71dbc139d735c9d522", "F*V(I)e^E#1108@3"));*/
        
        },

		mounted() {
			const emailInput = this.$refs.emailInput;
            emailInput.addEventListener('focus', () => {
                this.$trackEvent('FXView+Login+Email'); 
            });

			const passwordInput = this.$refs.passwordInput;
            passwordInput.addEventListener('focus', () => {
                this.$trackEvent('FXView+Login+Password'); 
            });

			
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/login.vue